<div class="share-content-editor row">
    <div class="ft-col-66">
        <div class="share-content-finished">
            <img [src]="sharing()?.shareImageUrl" />
        </div>
    </div>
    <div class="ft-col-33">
        <div class="modal-header">
            <div class="modal-heading">{{ 'flipto.account.ReadyToGo' | translate }}</div>
        </div>

        @if (!isInstagram(sharing()?.network)) {
            <div class="instructions">
                Here's the final rendered image. Click share if everything looks good. You can also
                <a (click)="download.emit(true)">download it</a>. If the image isn't displaying
                properly, cancel and try again to render a new image.
            </div>
        }
        @if (isInstagram(sharing()?.network)) {
            <div class="instructions">
                {{ 'flipto.account.ImageCreated' | translate }}
                <br /><br />
                {{ 'flipto.account.DownloadImageInstagramInstructions' | translate }}
            </div>
        }
        <div class="modal-footer">
            @if (isInstagram(sharing()?.network)) {
                <button
                    type="button"
                    class="ft-btn ft-btn-plus-1 ft-btn-default btn-confirm"
                    (click)="download.emit(false)"
                >
                    {{ 'flipto.account.Download' | translate }}
                </button>
            }
            @if (!isInstagram(sharing()?.network)) {
                <button
                    type="button"
                    class="ft-btn ft-btn-plus-1 ft-btn-default btn-confirm"
                    (click)="share.emit()"
                >
                    {{ 'flipto.account.Share' | translate }}
                </button>
            }

            <button
                type="button"
                class="ft-btn ft-btn-plus-1 ft-btn-outline-light btn-cancel"
                (click)="cancelClicked.emit()"
            >
                {{ 'flipto.account.Cancel' | translate }}
            </button>
        </div>
    </div>
</div>
